import { Settings } from '@models/settings';

export interface SettingsStateModel {
  settings: Settings;
  isLoading: boolean;
  isLoaded: boolean;
  isSaved: boolean;
  error: string | null;
}

export const settingsInitialState: SettingsStateModel = {
  settings: {
    toetsSettings: {
      defaultDatumAfnameVanaf: '',
      defaultDatumAfnameTot: '',
      defaultDatumInplanbaarVanaf: '',
      defaultDatumInplanbaarTot: '',
      specifiekeToetsSettings: [],
    },
    aanmeldenVODatumTot: '',
    aanmeldenVODatumVanaf: '',
    afnamesBeschikbaarVanaf: '',
    audioBeschikbaarDatumVanaf: '',
    campagneJaarDatumTot: '',
    campagneJaarDatumVanaf: '',
    datumInplanbaarTot: '',
    datumInplanbaarVanaf: '',
    inhaalDatumTot: '',
    inhaalDatumVanaf: '',
    inschrijvingDatumVanaf: '',
    pdfBeschikbaarDatumVanaf: '',
    plannenPapierDichtzettenDatum: '',
    rapportagesBeschikbaarVanaf: '',
    regulierDatumTot: '',
    regulierDatumVanaf: '',
    schooladviesDatumTot: '',
    schooladviesDatumVanaf: '',
    timestamp: '',
    voorlopigSchooladviesDatumTot: '',
    voorlopigSchooladviesDatumVanaf: '',
  },
  isLoading: false,
  isLoaded: false,
  isSaved: false,
  error: null,
};
